import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'multisesion',
})
export class MultisesionPipe implements PipeTransform {

  transform(items: any[], filter: any[]): any {

    if (filter && items) {


      if (filter['id_local'] && filter['id_local'] > 0) {

        items = items.filter(function (item) {

          return item.locales.includes(parseInt(filter['id_local'])) || item.locales.length == 0;
        });
      }

      if (filter['id_departamento'] && filter['id_departamento'] > 0) {

        items = items.filter(function (item) {

          return item.departamentos.includes(parseInt(filter['id_departamento'])) || item.departamentos.length == 0;
        });
      }

      if (filter['id_user'] && filter['id_user'] > 0) {

        items = items.filter(function (item) {

          return item.id != filter['id_user'];
        });
      }
    }
    return items;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/multisesion/multisesion.ts